import {v4 as uuid} from 'uuid';
import {IElementHtml} from '../incase-domain/elements/html/html';
import {isHtmlSlottedElement} from '../incase-domain/elements/html/htmlSlot';
import {ISlide} from '../incase-domain/slide';
import {parseHtmlInteractiveSlots} from '../service/presentation';
import {validateHtmlImageSizes} from './htmlEmbeddedImages';
import {htmlSlideName} from './htmlSlideImport';
import {linkQuestionReportSlots} from './linkHtmlQuestionReports';

export async function applyHtmlInteractiveImport(
    slide: ISlide,
    htmlElement: IElementHtml,
    rawHtml: string,
    fileName?: string,
    presentationSlides?: ISlide[]
): Promise<ISlide> {
    validateHtmlImageSizes(rawHtml);
    const parsed = await parseHtmlInteractiveSlots(rawHtml);

    const slottedElements = parsed.elements.map((element, index) => ({
        ...element,
        id: `${slide._id}-${uuid()}`,
        slideId: slide._id,
        elementIndex: index + 1,
    }));

    const updatedHtml: IElementHtml = {
        ...htmlElement,
        text: parsed.html,
        ...(slottedElements.length
            ? {
                  coverSlide: true,
                  fitContent: false,
                  xPosition: 0,
                  yPosition: 0,
                  width: '100%',
                  height: '100%',
              }
            : {}),
    };

    const withoutSlotted = (slide.elements || [])
        .filter((element) => !isHtmlSlottedElement(element))
        .map((element) => (element.id === htmlElement.id ? updatedHtml : element));

    const htmlPos = withoutSlotted.findIndex((element) => element.id === htmlElement.id);
    const insertAt = htmlPos >= 0 ? htmlPos + 1 : withoutSlotted.length;

    const nextName = fileName ? htmlSlideName(fileName) : slide.name;
    const nextSlide: ISlide = {
        ...slide,
        ...(nextName ? {name: nextName} : {}),
        elements: [...withoutSlotted.slice(0, insertAt), ...slottedElements, ...withoutSlotted.slice(insertAt)],
    };

    linkQuestionReportSlots(
        [
            {name: nextSlide.name, elements: nextSlide.elements},
            ...(presentationSlides ?? [])
                .filter((item) => item._id !== slide._id)
                .map((item) => ({name: item.name, elements: item.elements})),
        ],
        true,
        nextSlide.name
    );

    return nextSlide;
}
